"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useBroadcastTimeRange = require("./useBroadcastTimeRange");
Object.keys(_useBroadcastTimeRange).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBroadcastTimeRange[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useBroadcastTimeRange[key];
    }
  });
});